<template>
  <th v-if="tag === 'th'" v-bind="attributes" v-html="content" />
  <td v-else v-bind="attributes" v-html="content" />
</template>

<script setup lang="ts">
defineProps<{
  tag: string
  content: string
  attributes?: Record<string, string>
}>()
</script>
